import React, { useState } from 'react';
import { Provider as LandbotProvider } from '../context/landbot.context';

export default function LandbotService(props) {
  const [landbot, setLandbot] = useState(null);

  return (
    <LandbotProvider value={{ landbot, setLandbot }}>
      {props.children}
    </LandbotProvider>
  );
}
